import { render, staticRenderFns } from "./CajaMovimiento.vue?vue&type=template&id=675af992"
import script from "./CajaMovimiento.vue?vue&type=script&lang=ts"
export * from "./CajaMovimiento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports